import http from "api/http.js"
// const _PLATFORM = window.g.PLATFORM?window.g.PLATFORM:''
/**
 * post、get、put
 * http.post('url', params, 'query');
 * url:接口
 * params:参数
 * query:传参格式，默认为 data(body)传参，
 *      设置 query 为 params(query)传参，格式为：url?xx=xx
 * queryAndBody: 参数是否包含两个格式  query、body
 *    默认：false,
 *    如果设置为true
 *    参数形式如下，bodyObject内参数会在body传参，params 参数为 url?xxx=xxx
 *    params={
 *      xxx:xxx,
 *      bodyObject:String
 *    }
 */

//系统用户登录 (获取 Jwt 授权数据)
export const userLogin = params => {
  return http.post("/api/Jwt/token", params);
};
//根据Token获取用户信息
export const getUserByToken = params => {
  return http.post("/api/Jwt/GetUserByToken", params);
};
//验证码短信发送
export const verificationCodeSMS = params => {
  return http.post("/api/Jwt/VerificationCodeSMS", params);
};
//根据验证码获取JWT令牌
export const verificationCodeLogin = params => {
  return http.post("/api/Jwt/VerificationCodeLogin", params);
};
//刷新 Jwt 授权数据
export const refreshAccessToken = params => {
  return http.post("/api/Jwt/RefreshAccessToken", params);
};
// token过期的令牌刷新
export const refreshToken = params => {
  return http.post('/api/Jwt/RefreshToken', params)
}
// 刷新redis缓存
export const refreshCache = params => {
  return http.post("/api/Jwt/RefreshCache", params);
};
//获取接口版本
export const getApiVersion = params => {
  return http.get("/api/Jwt/getversion", params);
};
//通知openid退出登录
export const logoutOpenId = params => {
    return http.get("/api/Jwt/logout", params,'query');
  };

//修改密码 加密
export const putSysUserChangePasswordByEncrypt = params => {
  return http.post("/api/SysUser/ChangePasswordByEncrypt", params);
};
//修改密码 加密
export const putSysUserChangePasswordByBase64 = params => {
  return http.post("/api/SysUser/ChangePasswordByBase64", params);
};
//获取用户拥有权限的菜单树列表数据
export const getUserMenuTreeList = params => {
  return http.get("/api/SysUser/GetUserMenuTreeList", params, "query");
};
//获取用户拥有权限的菜单树列表数据 包含菜单对应的权限
export const getSysUserUserMenuTreeAndRightList = params => {
  return http.get("/api/SysUser/GetUserMenuTreeAndRightList", params, "query");
};
//获取用户的应用数据权限数据
export const getSysUserGetUserDataAuthority = params => {
  return http.get("/api/SysUser/GetUserDataAuthority", params, "query");
};
//修改用户的应用数据权限数据
export const postSysUserGetUserDataAuthority = params => {
  return http.post("/api/SysUser/SetUserDataAuthority", params);
};
//获取科室列表
export const getDeptList = params => {
  return http.get('/api/SysDepartment/GetList',params, "query");
};
//修改密码
export const putSysUserChangePassword = params => {
 return http.post("/api/SysUser/ChangePassword", params);
};
//用户解锁
export const putSysUserUnLock = params => {
 return http.post("/api/SysUser/UnLock", params, 'query');
};
//获取当前用户当前应用的医院列表
export const GetUserHospitalList = params =>{
    return http.get("/api/SysUser/GetUserHospitalList",params,'query')
}

/**
 * 用户管理
 */
 export const getUserPages = params => {
  return http.get("/api/SysUser/GetPages", params, "query");
}
//删除
export const deleteUser = params => {
  return http.post("/api/SysUser/Delete", params,'query');
}
//密码重置
export const resetUserPwd = params => {
  return http.post(`/api/SysUser/RestPasswordByPwd`,params);
}
//获取当前用户角色和医院
export const getUserHospitalAndRoleList = params => {
  return http.get(`/api/SysUser/GetUserHospitalAndRoleList`, params, "query");
}
export const setUserHospitalAndRoleList = params => {
  return http.post(`/api/SysUser/SetUserRoleAndHospitals`, params);
}
//导入信息
export const importUserList = params => {
  return http.post(`/api/SysUser/ImportUserList`, params);
}
//导入用户信息
export const importUserExList = params => {
  return http.post(`/api/SysUser/ImportUserExList`, params);
}
//设置用户状态
export const setUserStatus = params => {
  return http.post("/api/SysUser/SetUserStatus", params);
}
// 获取专家用户分页列表数据 非本人和同一个申请单id在申请单专家关联表里不存在的用户
export const getSysUserGetPagesByExpert = params => {
  return http.get("/api/SysUser/GetPagesByExpert",params, 'query');
}
// 获取专家用户权限的应用列表
export const getSysUserGetUserAppList = params => {
  return http.get("/api/SysUser/GetUserAppList",params, 'query');
}

//new
/**
 *
 * common
 */

//获取医院列表数据
export const getSysHospitalGetList = params => {
  return http.get("/api/SysHospital/GetList", params, "query");
};
//获取科室列表数据
export const getSysDepartmentGetList = params => {
  return http.get("/api/SysDepartment/GetList", params, "query");
};

 /* 个人信息
 */
// 获取用户信息
export const getSysUserModel = params => {
  return http.get("/api/sysUser/GetModel", params, "query");
}
// 修改用户信息
export const updateSysUserModel = params => {
  return http.post("/api/sysUser/put", params);
}
// 修改当前用户信息
export const PutCurrentUser = params => {
    return http.post("/api/SysUser/PutCurrentUser", params);
}
//新增用户信息
export const addSysUser = params => {
  return http.post("/api/sysUser/Post", params);
}
// 获取当前用户账号密码
export const GetUserPwdByToken = params => {
    return http.post("/api/Jwt/GetUserPwdByToken", params,'query');
}
/**
 * 应用管理
 */
//获取
export const getSysAppPages = params => {
  return http.get("/api/SysApp/GetPages", params, "query");
}
export const getSysAppById = params => {
    return http.get("/api/SysApp/GetModel", params, "query");
}
//新增
export const addSysAppPages = params => {
  return http.post("/api/SysApp/Post", params);
}
//详情
export const getSysAppModel = params => {
  return http.get("/api/SysApp/GetModel", params , "query");
}
//修改
export const updateSysAppPages = params => {
  return http.post("/api/SysApp/Put", params);
}
//删除
export const deleteSysAppPages = params => {
  return http.post("/api/SysApp/Delete", params,'query');
}

/**
 * 医院管理
 */
//获取
export const getSysHospPages = params => {
  return http.get("/api/syshospital/getpages", params, "query");
}
//新增
export const addSysHosp = params => {
  return http.post("/api/SysHospital/Post", params);
}
//修改
export const putSysHosp = params => {
  return http.post("/api/SysHospital/Put", params);
}
//删除
export const deleteSysHosp = params => {
  return http.post("/api/SysHospital/Delete", params,'query');
}
//详情
export const getSysHospModel = params => {
  return http.get("/api/SysHospital/GetModel", params, "query");
}
//复制
export const copySysHosp = params => {
  return http.post("/api/SysHospital/Copy", params);
}
//启用
export const aduitSysHosp = params => {
  return http.post(`/api/SysHospital/Aduit?id=${params.id}`);
}
//禁用
export const unaduitSysHosp = params => {
  return http.post(`/api/SysHospital/UnAduit?id=${params.id}`);
}

// 医院配置
// 获取配置详情 by hospitalId
export const getTMdtHospitalSetGetModel = params => {
  return http.get(`/api/TMdtHospitalSet/GetModel?id=${params.id}`)
}
// 新增
export const postTMdtHospitalSetInsertOrUpdate = params => {
  return http.post("/api/TMdtHospitalSet/InsertOrUpdate", params)
}
// 删除
export const deleteTMdtHospitalSetDelete = params => {
  return http.post(`/api/TMdtHospitalSet/Delete?id=${params.id}`)
}


/**
 * 权限
 */
export const getSysRightPages = params => {
  return http.get("/api/SysRight/getpages", params, "query");
}
//获得权限tree形式
export const getSysRightTree = params => {
  return http.get("/api/SysRight/GetRightTreeList", params, "query");
}
//获得权限
export const getSysRightList = params => {
  return http.get("/api/SysRight/getList", params, "query");
}
//获得应用系统
export const getSysAppList = params => {
  return http.get("/api/SysApp/GetList", params, "query");
}
//获得api列表
export const getSysApiList = params => {
  return http.get("/api/SysApi/GetList", params, "query");
}

//获得权限详情
export const getSysRightModel = params => {
  return http.get("/api/SysRight/GetModel", params, "query");
}
export const getSysRightModelAndApi = params => {
  return http.get("/api/SysRight/GetModelAndApi", params, "query");
}
//删除权限
export const deleteSysRightModel = params => {
  return http.post("/api/SysRight/Delete", params,'query');
}
//添加权限
export const postSysRightApi = params => {
  return http.post("/api/SysRight/PostAndApi", params);
}
//修改权限
export const putSysRightApi = params => {
  return http.post("/api/SysRight/PutAndApi", params);
}


/**
 * 角色管理
 */
export const getSysRolePages = params => {
  return http.get("/api/SysRole/GetPages", params, "query");
}
export const getSysRoleList = params => {
  return http.get("/api/SysRole/GetList", params, "query");
}
//包含角色对应权限
export const getSysRoleModelAndRight = params => {
  return http.get("/api/SysRole/GetModelAndRight", params, "query");
}

//获取所有权限
export const getSysRightTableList = params => {
  return http.get(`/api/SysRight/GetTableList`, params, "query");
}
//新增
export const addRoleAndRight = params => {
  return http.post("/api/SysRole/PostAndRight", params);
}
//修改系统角色信息 同步删除之前的角色权限，新增现在的角色权限
export const putRoleAndRight = params => {
  return http.post("/api/SysRole/PutAndRight", params);
}
//删除系统角色信息 同步删除该角色的权限数据
export const deleteSysRole = params => {
  return http.post("/api/SysRole/Delete", params,'query');
}

/**
 * 菜单管理
 */
export const getMenuTreeList = params => {
  return http.get("/api/SysMenu/GetMenuTreeList", params, "query");
}
//新增菜单信息和菜单权限
export const addMenuAndRight = params => {
  return http.post("/api/SysMenu/PostAndRight", params);
}
//修改菜单信息和菜单权限
export const updateMenuAndRight = params => {
  return http.post("/api/SysMenu/PutAndRight", params);
}
//菜单详情
export const getMenuModelAndRight = params => {
  return http.get("/api/SysMenu/GetModelAndRight", params, "query");
}
//删除系统菜单信息 同步删除该菜单的权限数据
export const deleteSysMenu = params => {
  return http.post("/api/SysMenu/Delete", params,'query');
}


/**
 * 科室管理
 */
export const getDeptPages = params => {
  return http.get("/api/SysDepartment/GetPages", params, "query");
}
//获取详情
export const getDeptModel = params => {
  return http.get("/api/SysDepartment/GetModel", params, "query");
}

//根据唯一代码获取全树
export const getWholeTreeListByCode = params => {
  return http.get(`/api/SysDictionaryMulti/GetWholeTreeListByCode`, params, "query");
}
//添加
export const addDept = params => {
  return http.post(`/api/SysDepartment/Post`, params);
}
//修改
export const updateDept = params => {
  return http.post(`/api/SysDepartment/Put`, params);
}
//删除
export const deleteDept = params => {
  return http.post("/api/SysDepartment/Delete", params,'query');
}
// 设置科室数据权限
export const postDeptSetSysDepartmentDataAuthority = params => {
  return http.post("/api/SysDepartment/SetSysDepartmentDataAuthority", params);
}
// 获取科室数据权限
export const getDeptGetSysDepartmentDataAuthority = params => {
  return http.get("/api/SysDepartment/GetSysDepartmentDataAuthority", params, 'query');
}

/**
 * webapi
 */
export const getSysApiPages = params => {
  return http.get("/api/SysApi/GetPages", params, "query");
}
//获取详情
export const getSysApiModel = params => {
  return http.get("/api/SysApi/GetModel", params, "query");
}
//添加
export const addSysApi= params => {
  return http.post(`/api/SysApi/Post`, params);
}
//修改
export const updateSysApi = params => {
  return http.post(`/api/SysApi/Put`, params);
}
//删除
export const deleteSysApi = params => {
  return http.post("/api/SysApi/Delete", params,'query');
}

/**
 * 系统日志管理
 */
export const getSysLogInfoGetPages = params => {
  return http.get("/api/SysLogInfo/GetPages", params, "query");
}
//获取详情
export const getSysLogInfoGetModel = params => {
  return http.get("/api/SysLogInfo/GetModel", params, "query");
}
//获取相关
export const getSysLogInfoGetFlogContentList = params => {
  return http.get("/api/SysLogInfo/GetFlogContentList", params, "query");
}

/**
 * group
 */
export const getTRemoteTeamPages = params => {
  return http.get("/api/TRemoteTeam/GetPages", params,'query');
};
//添加或编辑Remote小组
export const updateTRemoteTeamPages = params => {
  return http.post("/api/TRemoteTeam/InsertOrUpdate", params);
};
//获取Remote小组信息和成员
export const getTRemoteTeamModel = params => {
  return http.get("/api/TRemoteTeam/GetModel", params,'query');
};
//禁用小组
export const diableTRemoteTeam = params => {
  return http.post("/api/TRemoteTeam/Disable", params ,'query');
};
//激活小组
export const putdiableTRemoteTeamActivation = params => {
  return http.post("/api/TRemoteTeam/Activation", params ,'query');
};
//删除小组
export const deletediableTRemoteTeamDelete = params => {
  return http.post("/api/TRemoteTeam/Delete", params,'query');
};
//获取未指定专家列表 改成了分页
export const getNAppointedExperts = params => {
  return http.get("/api/TRemoteTeamExpert/GetExpertList",params, 'query');
};
//获取未指定专家列表 list
export const getNAppointedExpertsList = params => {
  return http.get("/api/TRemoteTeamExpert/GetList",params, 'query');
};
// 患者附件
//获取患者附件列表数据
export const getPatAttachmentList = params => {
  return http.get("/api/PatAttachment/GetList", params, "query");
};
//新增患者附件信息
export const addPatAttachment = params => {
  return http.post("/api/PatAttachment/Post", params);
};
//删除患者附件信息
export const deletePatAttachment = params => {
  return http.post("/api/PatAttachment/Delete", params,'query');
};

// 数据字典====
//获取系统字典列表数据 获取主树
export const getSysDictionaryMultiGetTree = params => {
  return http.get("/v2.1/dictionary_multi/tree", params, "query");
};

// 获取权限数据树
export const getSysDictionaryMultiGetTreePermission = params => {
  return http.get("/v2.1/dictionary_multi/check_tree", params, "query");
};
// 根据code获取树
export const getSysDictionaryMultiGetTreeByCode = params => {
  return http.get("/v2.1/dictionary_multi/tree/code", params, "query");
};
// 导入数据
export const postSysDictionaryMultiFileJson = params => {
  return http.post(`/v2.1/dictionary_multi/file`, params, 'query', true);
};
// 导入检查检验数据
export const standardItemExceljson = params => {
    return http.postFormData(`/standardItem/exceljson`, params, 'query', true,window.g.API_ROOT_OTHER);
};
// 根据ID获取树
export const getSysDictionaryMultiGetTreeById = params => {
  return http.get("/v2.1/dictionary_multi/tree", params, "query");
};
// 根据ID复制数据字典节点
export const postSysDictionaryMultiCopy = params => {
  return http.post("/v2.1/dictionary_multi/copy", params, 'query');
};
// 根据ID获取子树
export const getSysDictionaryMultiGetSubtreeById = params => {
  return http.get("/v2.1/dictionary_multi/sublist", params, "query");
};
 //获取系统字典列表数据 根据ID获取对象
export const getSysDictionaryMultiGet = params => {
  return http.get("/v2.1/dictionary_multi", params, "query");
  // if(_PLATFORM === 'xt'){
  // }else{
  //   return http.get("/api/SysDictionaryMulti/Get", params, "query");
  // }
};
//获取系统字典列表数据子级 根据ID获取子级
export const getSysDictionaryMultiGetSubtree = params => {
  return http.get("/api/SysDictionaryMulti/GetSubtree", params, "query");
};
 //获取系统字典列表数据子级byCode
export const getSysDictionaryMultiGetByCode = params => {
  return http.get("/v2.1/dictionary_multi/code", params, "query");
  // if(_PLATFORM === 'xt'){
  // }else{
  //   return http.get("/api/SysDictionaryMulti/GetByCode", params, "query");
  // }
};
 //新增数据字典树形菜单
export const postSysDictionaryMultiPost = params => {
  return http.post("/v2.1/dictionary_multi", params);
  // if(_PLATFORM === 'xt'){
  // }else{
  //   return http.post("/api/SysDictionaryMulti/Post", params);
  // }
};
//修改 数据字典内容
export const putSysDictionaryMultiPut = params => {
  return http.post("/v2.1/dictionary_multi/put", params);
  // if(_PLATFORM === 'xt'){
  // }else{
  //   return http.post("/api/SysDictionaryMulti/Put", params);
  // }
};
//删除 数据字典内容
export const deleteSysDictionaryMultiDelete = params => {
  return http.post(`/v2.1/dictionary_multi/${params.id}`);
  // if(_PLATFORM === 'xt'){
  // }else{
  //   return http.post("/api/SysDictionaryMulti/Delete", params);
  // }
};

//修改 数据字典树形菜单排序
export const putSysDictionaryMultiSort = params => {
  return http.post("/v2.1/dictionary_multi/sort", params, "query", true);
  // if(_PLATFORM === 'xt'){
  // }else{
  //   return http.post("/api/SysDictionaryMulti/Sort", params, "query", true);
  // }
};
//移动 数据字典树形菜单移动
export const putSysDictionaryMultiMove = params => {
  return http.post("/v2/dictionary_multi/parentid", params, "query",);
};
// 数据字典，导入数据
export const putSysDictionaryMultiEquipmentPartSynchronization = params => {
  return http.post("/v2/dictionary_multi/equipment_part_synchronization", params);
};
//获取数据字典树形菜单根据ID获取子集
export const getSysDictionaryMultiGetChildrenList = params => {
  return http.get("/api/SysDictionaryMulti/GetChildrenList", params, "query");
};
//模板管理根据唯一代码获取全树
export const getSysDictionaryMultiGetWholeTreeListByCode = params => {
  return http.get("/v2.1/dictionary_multi/tree/code", params, "query");
};
//获取数据字典树形菜单根据ID获取子集
export const getRemoteTemplateGetPages = params => {
  return http.get("/api/RemoteTemplate/GetPages", params, "query");
};
//新增模板表信息
export const postRemoteTemplatePost = params => {
  return http.post("/api/RemoteTemplate/Post", params);
};
//修改模板表信息
export const putRemoteTemplatePut = params => {
  return http.post("/api/RemoteTemplate/Put", params, "query");
};
//删除模板表信息
export const deleteRemoteTemplateDelete = params => {
  return http.post("/api/RemoteTemplate/Delete", params,'query');
};

/**
 * 模板管理
 * @param {RemoteTemplate} params
 */
//模版数据
export const getModelRemoteTemplate = params => {
  return http.get("/api/RemoteTemplate/GetModel", params);
};
//模版分页
export const getPagesRemoteTemplate = params => {
  return http.get("/api/RemoteTemplate/GetPages", params, "query");
};
/**
 * 模板管理
 */
//模板种类(TEMPLATE_TYPE)获取 模板所属获取(TEMPLATE_BELONG)  模板类型获取(TEMPLATE_STYLE)
export const getTempDictionary = params => {
  return http.get("/v2/dictionary_multi/sublist/code", params, "query");
  // if(_PLATFORM === 'xt'){
  // }else{
  //   return http.get("/api/SysDictionaryMulti/GetChildrenListByCode", params, "query");
  // }
};
//获取全树
export const getTempGroupWholeTree = params => {
  return http.get("/api/SysTemplateGroup/WholeTree", params, "query");
};
//根据id获取模板组的实体
export const getTempGroupModel = params => {
  return http.get("/api/SysTemplateGroup/" + params, {}, "query");
};
//根据id获取模板的实体
export const getTempModel = params => {
  return http.get("/api/SysTemplate/" + params.id, params, "query");
};
//添加组
export const addTempGroup = params => {
  return http.post("/api/SysTemplateGroup", params);
};
//添加模板
export const addTemp = params => {
  return http.post("/api/SysTemplate", params);
};
//上移组
export const upTempGroup = params => {
  return http.post("/api/SysTemplateGroup/Up/" + params, {});
};
//下移组
export const downTempGroup = params => {
  return http.post("/api/SysTemplateGroup/Down/" + params, {});
};
//上移
export const upTemp = params => {
  return http.post("/api/SysTemplate/Up/" + params, {});
};
//下移
export const downTemp = params => {
  return http.post("/api/SysTemplate/Down/" + params, {});
};
//删除组
export const deleteTempGroup = params => {
  return http.post("/api/SysTemplateGroup/" + params, {});
};
//删除
export const deleteTemp = params => {
  return http.post("/api/SysTemplate/" + params, {});
};
//修改模板组名称
export const updateTempTitle = params => {
  return http.post(`/api/SysTemplateGroup/${params.id}/${params.title}`, {});
};
//修改模板
export const updateTemp = params => {
  return http.post('/api/SysTemplate/put', params);
};
//获取第一级列表
export const getFirstGroup = params => {
  return http.get('/api/SysTemplateGroup/First', params, "query");
};
//获取下一级
export const getLowerLevel = params => {
  return http.get('/api/SysTemplateGroup/LowerLevel/' + params.id, params, "query");
};
//获取主树到第二层
export const getTempGroupTree = params => {
  return http.get("/api/SysTemplateGroup/Tree", params, "query");
};

export const getQcDictionaryGetPages = params => {
  return http.get("/api/QcDictionary/GetPages", params, "query");
}; //获取质控评价字典分页列表数据

export const getQcDictionaryGetList = params => {
  return http.get("/api/QcDictionary/GetList", params, "query");
}; //获取质控评价字典列表数据

export const postQcDictionaryPost = params => {
  return http.post("/api/QcDictionary/Post", params);
}; //新增质控评价字典信息

export const putQcDictionaryPut = params => {
  return http.post("/api/QcDictionary/Put", params);
}; //修改质控评价字典信息

export const deleteQcDictionaryDelete = params => {
  return http.post("/api/QcDictionary/Delete", params,'query');
}; //删除质控评价字典信息

// 获取系统字典列表数据
export const getSysDictionaryGetList = params => {
  return http.get("/api/SysDictionary/GetList", params, "query");
}

//获取确诊病人表分页列表数据
export const getExConfirmedPatientsGetPages = params => {
  return http.get("/api/ExConfirmedPatients/GetPages", params);
};

//获取传染病监测信息对象
export const getExJgzxInfectiousMonitoringModel = params => {
  return http.get("/api/ExJgzxInfectiousMonitoring/GetModel", params, "query");
};

//获取疫情报告分页列表数据
export const getEpidemicReportPages = params => {
  return http.get("/api/EpidemicReport/GetPages", params, "query");
};

//获取疫情报告历史分页列表数据
export const getEpidemicReportLogPages = params => {
  return http.get("/api/EpidemicReport/GetLogPages", params, "query");
};

// 组
//获取组列表数据\分页
export const getTRemoteTeamGetPages = params => {
  return http.get("/api/TRemoteTeam/GetPages", params, "query");
};
//获取组成员数据
export const getTRemoteTeamExpertGetRemoteTeamExpertList = params => {
  return http.get("/api/TRemoteTeamExpert/GetRemoteTeamExpertList", params, "query");
};

//获取会诊申请患者信息
export const getRemoteApplyPatInfo = params => {
  return http.get("/api/EpidemicReport/GetModel", params, "query");
};
//获取疫情检查明细分页列表数据
export const getEpidemicExamInfoPages = params => {
  return http.get("/api/EpidemicExamInfo/GetPages", params, "query");
};
//删除疫情检查明细信息
export const deleteEpidemicExamInfo = params => {
  return http.post("/api/EpidemicExamInfo/Delete", params,'query');
};
//新增患者
export const postEpidemicReportSetPatExamAndAtt = params => {
  return http.post("/api/EpidemicReport/SetPatExamAndAtt", params);
};
// 获取(添加)患者信息对象
export const getEpidemicReportGetModelByPat = params => {
  return http.get("/api/EpidemicReport/GetModelByPat", params, "query");
};

// 会场管理
// 获取会场列表，分页
export const getTRemoteMeetingGetPages = params => {
  return http.get("/api/TRemoteMeeting/GetPages", params, "query");
}
// 获取会场列表
export const getTRemoteMeetingGetList = params => {
  return http.get("/api/TRemoteMeeting/GetList", params, "query");
}
// 获取会议室信息和成员
export const getTRemoteMeetingGetModel = params => {
  return http.get("/api/TRemoteMeeting/GetModel", params, "query");
}
// 添加或编辑会议室
export const postTRemoteMeetingInsertOrUpdate = params => {
  return http.post("/api/TRemoteMeeting/InsertOrUpdate", params);
}
// 禁用会议室
export const putTRemoteMeetingDisable = params => {
  return http.post("/api/TRemoteMeeting/Disable", params, "query");
}
// 激活会议室
export const putTRemoteMeetingActivation = params => {
  return http.post("/api/TRemoteMeeting/Activation", params, "query");
}
// 删除会议室
export const deleteTRemoteMeetingDelete = params => {
  return http.post("/api/TRemoteMeeting/Delete", params,'query');
}

//互认项目匹配 查询
export const standardItemByPage = params =>{
    return http.get("standardItem/page", params, "query",window.g.API_ROOT_OTHER);
}
//互认项目匹配 新增
export const addStandardItem = params =>{
    return http.post("standardItem", params,'','',window.g.API_ROOT_OTHER);
}
//互认项目匹配 修改
export const updateStandardItem = params =>{
    return http.post("standardItem", params,'','',window.g.API_ROOT_OTHER);
}
//互认项目匹配 删除
export const deleteStandardItem = params =>{
    return http.post("standardItem", params,window.g.API_ROOT_OTHER);
}
//互认项目匹配 详情
export const standardItemById = params =>{
    return http.get("standardItem", params, "query",window.g.API_ROOT_OTHER);
}
//互认项目匹配 院内项目下拉
export const inCodeListApi = params =>{
    return http.get("/v2.1/dictionary_multi/sublist/code", params,'query');
}
//获取角色用户列表数据
export const getHasUserRolePages = params =>{
    return http.get('/api/SysUser/GetHasUserRolePages',params,'query')
}
//设置用户角色列表
export const setRoleUsers = params =>{
    return http.post('/api/SysRole/SetRoleUsers',params)
}
//删除角色用户列表
export const removeRoleUsers = params =>{
    return http.post('/api/SysRole/RemoveRoleUsers',params)
}
//获取用户的应用角色医院数据
export const GetUserAppRoleList = params =>{
    return http.get('/api/SysUser/GetUserAppRoleList',params,'query')
}
//获取CA登录二维码
export const GetCaQrCode = params =>{
    return http.get('/api/SysUserCa/GetCaQrCode',params,'query')
}
//判断CA是否登录
export const CaQrCodeLogin = params =>{
    return http.post('/api/SysUserCa/CaQrCodeLogin',params)
}
//获取登录二维码----兰天球的登录二维码
export const getLoginUrl = params =>{
    return http.get('/integration-master/api/qr/qrlogin',params,'query',window.g.API_ROOT_QR)
}
//获取二维码登录状态----兰天球的登录二维码
export const getLoginStatus = params =>{
    return http.get('/integration-master/api/qr/getLoginStatus',params,'query',window.g.API_ROOT_QR)
}
//数据字典----根据唯一代码获取下拉列表数据
export const selectDicCode = params =>{
    return http.get("/v2.1/dictionary_multi/select/code", params, "query");
}
//hisToken校验登录
export const hisTokenApi = params =>{
    return http.post('/api/Jwt/HIStoken',params)
}
//sm2国密登录
export const tokensm2 = params =>{
    return http.post('/api/Jwt/tokensm2',params)
}
//sm2国密登录----只有工号
export const usercodesm2 = params =>{
    return http.post('/api/Jwt/usercodesm2',params)
}
//新增索引
export const AddIndexItem = params =>{
    return http.post('/api/AddItem',params,'','',window.g.API_ROOT_KING)
}
//修改索引
export const EditIndexItem = params =>{
    return http.post('/api/EditItem',params,'','',window.g.API_ROOT_KING)
}
//查询索引
export const SearchAllIndexItem = params =>{
    return http.post('/api/SearchAll',params,'','',window.g.API_ROOT_KING)
}
//删除索引
export const DeleteIndexItem = params =>{
    return http.post('/api/DeleteItem',params,'','',window.g.API_ROOT_KING)
}
//合并索引
export const MergeIndexItem = params =>{
    return http.post('/api/Merge',params,'','',window.g.API_ROOT_KING)
}
//获取用户应用权限列表数据
export const GetSysUserRightList = params =>{
    return http.get('/api/SysUser/GetSysUserRightList',params,'query')
}
//获取用户对应应用的角色名称
export const GetUserRoleNames = params =>{
    return http.post('/api/SysUser/GetUserRoleNames',params)
}
//批量用户设置系统角色
export const SetUserListRoleAndHospitals = params =>{
    return http.post('/api/SysUser/SetUserListRoleAndHospitals',params)
}
//获取应用角色二级树
export const GetAppRoleTreeList = params =>{
    return http.get('/api/SysRole/GetAppRoleTreeList',params)
}
//批量绑定角色
export const SetUserListRoles = params =>{
    return http.post('/api/SysUser/SetUserListRoles',params)
}
//获取科室拥有权限列表
export const GetDepartmentAppRoleList = params =>{
    return http.get('/api/SysDepartment/GetDepartmentAppRoleList',params,'query')
}
//科室绑定角色
export const SetDepartmentListRoles = params =>{
    return http.post('/api/SysDepartment/SetDepartmentListRoles',params)
}
//清空科室下所有用户权限
export const RemoveDepUserRoles = params =>{
    return http.post('/api/SysUser/RemoveDepUserRoles',params)
}
//批量设置用户所属科室
export const SetUserDepartmentList = params =>{
    return http.post('/api/SysUser/SetUserDepartmentList',params)
}

// 项目对码流水
export const getUserStandardItemList = params =>{
  return http.get('standardItem/log/page',params, "query",window.g.API_ROOT_OTHER)
}

//获取随机数
export const dashboardGetNonce = params =>{
    return http.get('/dashboard/get_nonce/',params, "query",window.g.API_ROOT_THREE)
}

//第三方验签接口
export const getDashboardVerifySignature = params =>{
    return http.post('/dashboard/verify_signature/',params,'','',window.g.API_ROOT_THREE)
}
//下载初始化种子数据脚本：向数据库中添加种子数据，在数据库初始化时填充一些默认的基础数据
export const seedDatabase = params =>{
    return http.get('/api/SysHospital/SeedDatabase',params,"query")
}
//下载数据库迁移脚本：自动创建或更新数据库，不存在的列才新增不做其他修改或删除操作
export const migration = params =>{
    return http.get('/api/SysHospital/Migration',params,"query")
}
//下载对应应用的所有基础数据Json脚本
export const GetJsonData = params =>{
    return http.get('/api/SysApp/GetJsonData',params,"query")
}
//获取应用参数分页列表数据
export const SysAppConfigGetPages = params => {
  return http.get("/api/SysAppConfig/GetList", params, 'query');
}
//新增应用参数信息
export const SysAppConfigPost =params =>{
    return http.post("/api/SysAppConfig/Post", params);
}
//修改应用参数信息
export const SysAppConfigPut = params =>{
    return http.post("/api/SysAppConfig/Put", params);
}
//删除应用参数信息
export const SysAppConfigDelete = params =>{
    return http.post("/api/SysAppConfig/Delete", params, 'query');
}
//获取应用分组列表数据
export const GetGroupNameList = params => {
  return http.get("/api/SysAppConfig/GetGroupNameList", params, 'query');
}
//获取应用参数列表数据。配置最后修改时间判断未修改会返回空数组
export const GetConfigList = params => {
  return http.get("/api/SysAppConfig/GetConfigList", params, 'query');
}
//获取后端接口配置
export const getappsettings = params => {
  return http.get("/api/Jwt/getappsettings", params, 'query');
}


// WEBPACK FOOTER //
// ./src/api/api.js